const EditIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="currentColor"
  >
    <path d="M222.22-222.78h51.56l336.57-336.57-50.44-51-337.69 337.7v49.87Zm-48.26 98q-20.26 0-34.72-14.26-14.46-14.25-14.46-34.56v-99.29q0-19.41 6.98-37.22 6.98-17.8 21.94-32.76l467.95-468.52q12.13-12.7 26.66-18.26 14.54-5.57 30.39-5.57 15.3 0 30 5.57 14.69 5.56 27.95 17.69l75.31 73.61q12.13 12.7 17.98 27.68 5.84 14.97 5.84 30.78 0 16.14-5.87 31.21t-17.95 27.03L344-153.7q-14.96 14.96-32.71 21.94t-37.13 6.98h-100.2Zm557.6-554.65L680-731.56l51.56 52.13Zm-146.6 94.47-25.05-25.39 50.44 51-25.39-25.61Z" />
  </svg>
);

export default EditIcon;
